import { rem } from 'polished';
import styled from 'styled-components';

export const SearchWrapper = styled.div`
  margin-right: ${rem(8)};
  height: ${rem(68)};
`;
